import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from '@kjotkompanid/i18n';

const preferredLocaleKey = 'kjot.preferred-locale';
const supportedLocales = new Set(Object.keys(resources));

export const resolvePreferredLocale = (candidate: string | null): string =>
  candidate && supportedLocales.has(candidate) ? candidate : 'en';

export const preferredLocale = (): string => {
  if (typeof window === 'undefined') return 'en';
  return resolvePreferredLocale(window.localStorage.getItem(preferredLocaleKey));
};

export const rememberLocale = (locale: string): void => {
  if (typeof window !== 'undefined' && supportedLocales.has(locale)) {
    window.localStorage.setItem(preferredLocaleKey, locale);
  }
};

void i18n.use(initReactI18next).init({
  resources: Object.fromEntries(
    Object.entries(resources).map(([locale, catalog]) => [
      locale,
      Object.fromEntries(
        Object.entries(catalog).map(([namespace, translations]) => [namespace, translations]),
      ),
    ]),
  ),
  lng: preferredLocale(),
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: [
    'common',
    'auth',
    'navigation',
    'users',
    'settings',
    'validation',
    'master',
    'products',
    'stores',
    'networks',
    'inventory',
    'sales',
    'salesImports',
    'importCenter',
    'shipmentWorkspace',
    'shipmentImports',
    'production',
    'dashboard',
    'operations',
    'forecast',
    'costing',
    'profitability',
    'orders',
    'abpCatalog',
  ],
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
